const DEFAULT_CLASSNAMES = {
  td: "w-full",
  input: "w-full font-ubuntuRegular shadow h-[36px] text-center p-1 rounded",
};

const TableDateTimePickerInput = ({
  classNames = DEFAULT_CLASSNAMES,
  value,
  ...otherProps
}) => {
  const convertedValue = value;
  return (
    <td className={classNames.td}>
      <input
        value={convertedValue}
        type="datetime-local"
        {...otherProps}
        className={classNames.input}
      />
    </td>
  );
};

export default TableDateTimePickerInput;
